(function () {
  'use strict';
  const lpmText = window.lpmText || (source => source);

  // El <script src=perso-wizard.js> vive DENTRO de snippets/perso-wizard.liquid, asi que el
  // re-render de la seccion de Prestige al cambiar de variante RE-INYECTA y RE-EJECUTA este
  // modulo -> un 2o boot() creaba una closure y un overlay duplicados (dos openWizard que se
  // podaban el overlay mutuamente y dejaban el wizard sin abrir). Guard global: la re-ejecucion
  // es un no-op; sobrevive el primer boot. La copia de overlay que deja el re-render se poda
  // en openWizard/al cambiar variante.
  if (window.__persoWizardLoaded) return;
  window.__persoWizardLoaded = true;

  // Productos con el wizard EN VIVO (mount generico activo para TODOS, sin ?pw=1).
  // Para publicar un producto: añade su handle aquí (tras validarlo en preview).
  var PW_LIVE = [
    // MIGRACIÓN TOTAL (21 jul 2026): todos los personalizables — QA preview 78/78 contra contratos Textify byte-exactos
    'name-necklace-personalised',
    'my-name-necklace-personalised',
    'unions-bracelet-personalised',
    'amity-necklace-personalised',
    'secret-bracelet-personalized',
    'alliance-bracelet-personalised',
    'arabic-name-necklace-personalised',
    'attachment-bracelet-personalized',
    'birth-necklace-personalised',
    'cordelia-bracelet-personalized',
    'courageous-bracelet-personalised',
    'dua-bracelet-personalised',
    'feeling-necklace-personalized',
    'forever-necklace-personalized',
    'heavenly-necklace-personalized',
    'identity-bracelet-personalized',
    'infinity-bracelet-personalised',
    'interstellar-necklace-personalized',
    'lord-brave-mens-bracelet-personalised',
    'medallion-bracelet-personalized',
    'pact-necklace-personalised',
    'passion-necklace-personalized',
    'pink-macrame-bracelet-personalized',
    'plate-necklace-personalized',
    'promise-necklace-personalized',
    'puzzle-necklace-personalized',
    'rebel-brave-mens-bracelet-personalised',
    'romantic-necklace-personalized',
    'rosicler-bracelet-personalized',
    'sensation-bracelet-personalised',
    // Lote 28 jul 2026 — contrato verificado contra pedidos reales
    'attachment-necklace-personalized', 'sensation-necklace-personalised', 'infinite-necklace-personalised', 'memories-necklace-personalised',
    // Lote 28 jul 2026 — resto de personalizables
    'heart-necklace-personalised', 'five-star-necklace-personalised', 'alliance-necklace-personalised', 'courageous-necklace-personalised', 'muse-necklace-personalized', 'medallion-necklace-personalized', 'pet-pendant-personalised', 'emotion-necklace-personalised', 'fate-necklace-personalized', 'pet-love-necklace-personalized', 'affection-necklace-personalised',
    // Lote 1 sep 2026 — altas del 30-ago que se publicaron sin registrar: comprables y sin
    // ninguna forma de capturar el grabado (ni wizard ni Textify).
    'eternal-bar-bracelet-personalized', 'dont-forget-me-bracelet-womens-personalized', 'dont-forget-me-bracelet-mens-personalized'
  ]; // amity+unions: plantilla bespoke (ATC oculto por CSS) — DEBEN estar aqui o el guard deja la PDP sin boton de compra

  // Activacion del mount generico: EN VIVO (PW_LIVE) o preview (?pw=1, persiste en sesion).
  // Marca html.pw-preview, que activa via CSS el boton del wizard + oculta Textify.
  // (Los productos con montaje bespoke -Amity- no dependen de esto.)
  try {
    var _pwActive = false;
    var _pw = new URLSearchParams(location.search).get('pw');
    if (_pw === '1') sessionStorage.setItem('pw_preview', '1');
    if (_pw === '0') sessionStorage.removeItem('pw_preview');
    if (sessionStorage.getItem('pw_preview') === '1') _pwActive = true;
    var _cfgEl = document.querySelector('[data-pw-config]');
    if (_cfgEl) { try { if (PW_LIVE.indexOf(JSON.parse(_cfgEl.textContent).handle) > -1) _pwActive = true; } catch (e) {} }
    if (_pwActive) document.documentElement.classList.add('pw-preview');
  } catch (e) {}
  // La app Teeinblue inyecta su clon de ATC tarde: si estamos en preview, lo neutralizamos en cuanto aparezca.
  try {
    if (document.documentElement.classList.contains('pw-preview')) {
      var _killTB = function () {
        document.querySelectorAll('[data-tb-clone-atc]').forEach(function (el) { el.style.display = 'none'; });
        // ocultar el BLOQUE de app entero que contiene los campos Teeinblue (no solo el input:
        // la etiqueta "Grabado Frontal" y el checkbox son hermanos dentro del bloque de app).
        document.querySelectorAll('[data-tb-app-fields]').forEach(function (f) {
          var blk = f.closest('.product-info__block-item') || f.closest('.shopify-block') || f.parentElement;
          // Si en ese bloque vive el boton del wizard, ocultar SOLO los campos de Textify: cuando
          // los inyecta dentro del bloque de buy_buttons, ocultar el bloque entero se llevaba
          // por delante el boton PERSONALIZALO y el ATC (reporte Olymar, amity en SOPH).
          if (blk && !blk.querySelector('[data-pw-open]')) blk.style.display = 'none';
          else f.style.display = 'none';
        });
      };
      _killTB();
      new MutationObserver(_killTB).observe(document.documentElement, { childList: true, subtree: true });
    }
  } catch (e) {}

  var LABELS = { front: 'Chapita {n} (Frontal)', back: 'Chapita {n} (Parte Detrás)' };
  var MAXLEN = 16;

  // Config POR PRODUCTO (registro por handle). Para aplicar el wizard a un producto
  // nuevo: añade su entrada aquí (addon de grabado detrás o null si solo frontal, y
  // las posiciones % del centro de cada plaquita por nº de nombres para los pins del
  // resumen), crea su plantilla product.<suffix>.json y asígnala en Admin.
  // Ver docs/perso-grabado-nativo.md.
  // SOPH (port 27-oct-2026): registro de Sophia (handles, addons y nombres de property del pedido en
  // inglés, contrato del taller) tomado del wizard que SOPH tenía en vivo, sobre el motor actual de LPM.
  // 'unit' y los textos de los nombres (frontLabel...) en inglés: el motor de LPM los pinta tal cual.
  var PRODUCTS = {
    'heart-necklace-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      // [real] pedido UK40148965 (12-jul-2026)
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Short Text to Save' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'five-star-necklace-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      // [real] pedido UK40147958 (23-jun-2026)
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Short Text to Save' },
      gate: { option: 'option2', skip: 'Not engraved' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'alliance-necklace-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      // [real] pedido UK40149759 (27-jul-2026)
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'courageous-necklace-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      // [real] pedido UK40147222 (9-jun-2026)
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'muse-necklace-personalized': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      // [real] pedido UK40149296 (18-jul-2026)
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'medallion-necklace-personalized': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      // [real] pedido UK40147879 (21-jun-2026)
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text (single side, front)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'pet-pendant-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      // [patron] sin pedidos; 'Text' es el contrato dominante en SOPH
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'emotion-necklace-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      // [patron] sin pedidos; 'Text' dominante en SOPH
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'fate-necklace-personalized': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      // [patron] sin pedidos; 'Text' dominante en SOPH
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'pet-love-necklace-personalized': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      // [patron] sin pedidos; 'Text' dominante en SOPH
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'affection-necklace-personalised': {
      unit: { one: 'tag', many: 'tags' },
      // [patron] sin pedidos; 2 corazones como en LPM (alli 'Corazon Pequeno'/'Corazon Grande')
      labels: { fronts: ['Small Heart', 'Big Heart'] },
      unitNames: ['Small heart', 'Big heart'],
      fixedUnits: 2,
      addon: null, plates: null
    },
    'attachment-necklace-personalized': {
      unit: { one: 'tag', many: 'tags' },
      // mismas property keys que la pulsera: el taller usa 'Necklace/Bracelet N'
      labels: { fronts: ['Necklace/Bracelet 1 (Small Circle)', 'Necklace/Bracelet 2 (Big Circle)'] },
      unitNames: ['Small circle', 'Big circle'],
      fixedUnits: 2,
      addon: null, plates: null
    },
    'sensation-necklace-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'infinite-necklace-personalised': {
      unit: { one: 'tag', many: 'tags' },
      labels: { front: 'Name {n}' },
      addon: null, plates: null
    },
    'memories-necklace-personalised': {
      unit: { one: 'tag', many: 'tags' },
      labels: { fronts: ['Front', 'Back', 'Side 1', 'Side 2'] },
      unitNames: ['Front', 'Back', 'Side 1', 'Side 2'],
      fixedUnits: 4,
      optional: [2, 3, 4],
      extraAddon: { id: 62049250640259, price: 90, freeUnits: 1 },
      addon: null, plates: null
    },
    'name-necklace-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      unitKey: 'name', uiKey: 'name', fixedUnits: 1,
      labels: { front: 'Text' },  // corte laser: el nombre ES la joya
      addon: null,
      plates: null
    },
    'my-name-necklace-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      unitKey: 'name', uiKey: 'name', fixedUnits: 1,
      labels: { front: 'Text' },  // property del pedido = 'Text' (paridad con Textify en estas tiendas)
      addon: null,  // sin grabado trasero
      plates: null
    },
    'unions-bracelet-personalised': {
      unit: { one: 'tag', many: 'tags' },
      unitKey: 'tag',
      addon: { id: 56994004828547, price: 190 },
      plates: {
        1: [{ x: 49, y: 86 }],
        2: [{ x: 27, y: 79 }, { x: 79, y: 75 }],
        3: [{ x: 16, y: 51 }, { x: 50, y: 85 }, { x: 87, y: 51 }]
      }
    },
    'amity-necklace-personalised': {
      unit: { one: 'ring', many: 'rings' },
      unitKey: 'ring',
      labels: { front: 'Ring {n} (Front)', back: 'Ring {n} (Back)' }, // property del pedido (fulfillment, en EN como Textify)
      addon: null,  // solo grabado frontal (sin grabado detras)
      plates: null  // sin imagen/pins en el resumen para este producto
    },
    'secret-bracelet-personalized': {
      unit: { one: 'name', many: 'names' },
      unitKey: 'name', fixedUnits: 1,
      labels: { front: 'FrontEngraving  (a)', back: 'EngravedBACK  (c)' }, // Teeinblue del DOM (⚠ confirmar con pedido)
      addon: { id: 62028625936771, price: 490 }, // suplemento dedicado creado (£4.90)
      plates: null
    },
    // ── Migración total (21 jul 2026): contratos scrapeados de Textify, byte-exactos ──
    'alliance-bracelet-personalised': {
      unit: { one: 'tag', many: 'tags' },
      labels: { front: 'Jewel - {n} Name/text' },
      addon: null, plates: null
    },
    'arabic-name-necklace-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Arab Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'attachment-bracelet-personalized': {
      unit: { one: 'tag', many: 'tags' },
      labels: { fronts: ['Necklace/Bracelet 1 (Small Circle)', 'Necklace/Bracelet 2 (Big Circle)'] },
      unitNames: ['Necklace/Bracelet 1 (Sma', 'Necklace/Bracelet 2 (Big'],
      fixedUnits: 2,
      addon: null, plates: null
    },
    'birth-necklace-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text (single side, front)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'cordelia-bracelet-personalized': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'courageous-bracelet-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'dua-bracelet-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'feeling-necklace-personalized': {
      unit: { one: 'tag', many: 'tags' },
      labels: { fronts: ['Name 1 Double Heart', 'Name 2 Double Heart'] },
      unitNames: ['Name 1 Double Heart', 'Name 2 Double Heart'],
      fixedUnits: 2,
      addon: null, plates: null
    },
    'forever-necklace-personalized': {
      unit: { one: 'tag', many: 'tags' },
      labels: { fronts: ['Big Heart Necklace', 'Small Heart Necklace'] },
      unitNames: ['Big Heart Necklace', 'Small Heart Necklace'],
      fixedUnits: 2,
      addon: null, plates: null
    },
    'heavenly-necklace-personalized': {
      unit: { one: 'tag', many: 'tags' },
      labels: { fronts: ['Circular pendant (star)', 'Little Star (sobresaliente)'] },
      unitNames: ['Circular pendant (star)', 'Little Star (sobresalien'],
      fixedUnits: 2,
      addon: null, plates: null
    },
    'identity-bracelet-personalized': {
      unit: { one: 'tag', many: 'tags' },
      // CB187. Se abre el grabado trasero (+1,90, decision de Adri 2-sep-2026): hasta hoy era
      // solo frontal. Con dos caras, 'Text (single side, front)' pasa a ser mentira, asi que los
      // labels van en par — el taller lo lee en pantalla, no hay codigo que dependa del texto.
      // Sin uiKey 'name': es una placa que se GRABA, no un nombre cortado a laser.
      labels: { front: 'Text (front)', back: 'Text (back)' },
      fixedUnits: 1,
      addon: { id: 56994004828547, price: 190 },
      plates: null
    },
    'infinity-bracelet-personalised': {
      unit: { one: 'tag', many: 'tags' },
      labels: { front: 'Name {n}' },
      addon: null, plates: null
    },
    'interstellar-necklace-personalized': {
      unit: { one: 'tag', many: 'tags' },
      labels: { fronts: ['Name 1 Double Star', 'Name 2 Double Star'] },
      unitNames: ['Name 1 Double Star', 'Name 2 Double Star'],
      fixedUnits: 2,
      addon: null, plates: null
    },
    'lord-brave-mens-bracelet-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      gate: { option: 'color', skip: 'Not engraved' }, // variante sin grabado → add directo
      addon: null, plates: null
    },
    'medallion-bracelet-personalized': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text (single side, front)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'pact-necklace-personalised': {
      unit: { one: 'tag', many: 'tags' },
      labels: { fronts: ['Necklace (pacto) - 1 Nombre', 'Necklace (pacto) - 2 Nombres'] },
      addon: null, plates: null
    },
    'passion-necklace-personalized': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'pink-macrame-bracelet-personalized': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text (single side, front)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'plate-necklace-personalized': {
      unit: { one: 'tag', many: 'tags' },
      labels: { front: 'FrontEngraving  (a)', back: 'EngravedBACK  (c)' },
      fixedUnits: 1,
      addon: { id: 56994004828547, price: 190 }, plates: null
    },
    'promise-necklace-personalized': {
      unit: { one: 'tag', many: 'tags' },
      labels: { fronts: [' Promise Necklace 1 (Amity Bicolor)', ' Promise Necklace 2 (Amity Bicolor)'] },
      unitNames: [' Promise Necklace 1 (Ami', ' Promise Necklace 2 (Ami'],
      fixedUnits: 2,
      addon: null, plates: null
    },
    'puzzle-necklace-personalized': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'rebel-brave-mens-bracelet-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      gate: { option: 'color', skip: 'Not Engraved' }, // variante sin grabado → add directo
      addon: null, plates: null
    },
    'romantic-necklace-personalized': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'rosicler-bracelet-personalized': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text (single side, front)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    // Altas del 30-ago-2026 (CB189/CB190/CB191). Sin ningun pedido real todavia en ninguna
    // tienda -> [patrón]: placa/barra de una sola cara, igual que rosicler y medallion.
    // ⚠️ Revisar el PRIMER pedido real de cada uno y ajustar el label si el taller espera otro.
    'eternal-bar-bracelet-personalized': {
      unit: { one: 'tag', many: 'tags' },
      labels: { front: 'Text (single side, front)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'dont-forget-me-bracelet-womens-personalized': {
      unit: { one: 'tag', many: 'tags' },
      labels: { front: 'Text (single side, front)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'dont-forget-me-bracelet-mens-personalized': {
      unit: { one: 'tag', many: 'tags' },
      labels: { front: 'Text (single side, front)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'sensation-bracelet-personalised': {
      unit: { one: 'name', many: 'names' },
      frontLabel: 'Which name do you want?', placeholder: 'Type the name (e.g. Emma)', stepTitle: 'Your name', reviewTitle: 'Review the name', sumLabel: 'Name',
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    }
  };

  function genGroupId() {
    return (Math.random().toString(36).slice(2, 10) + '0000000').slice(0, 8);
  }

  // Plantillas de label: {n} = nº de unidad; {a}/{b}/{c} = letra correlativa del taller
  // avanzando de 3 en 3 por unidad (unidad 1 → a/b/c, unidad 2 → d/e/f, unidad 3 → g/h/i).
  // Ej: 'Circulo{n}-Frontal  ({a})' con n=2 → 'Circulo2-Frontal  (d)' (contrato Textify de alianza/pacto).
  function label(tpl, n) {
    return tpl.replace('{n}', n).replace(/\{([abc])\}/g, function (_, l) {
      return String.fromCharCode(96 + (n - 1) * 3 + (l.charCodeAt(0) - 96));
    });
  }

  // Label frontal/trasero de la unidad i (0-based): labels.fronts[] (exactos por unidad,
  // p.ej. promesa/apego) tiene prioridad sobre la plantilla labels.front.
  function unitFrontLabel(labels, i) { return labels.fronts ? labels.fronts[i] : label(labels.front, i + 1); }
  function isOptionalUnit(optional, i) { return !!optional && optional.indexOf(i + 1) > -1; }
  function filledCount(state) {
    return (state.chapitas || []).filter(function (c) { return c && c.front && c.front.trim(); }).length;
  }

  function buildCartPayload(state, opts) {
    opts = opts || {};
    var addon = opts.addon || null;
    var labels = opts.labels || LABELS;   // label de property por producto (default: Chapita)
    var optional = opts.optional || null; // unidades (1-based) que pueden ir vacías → no emiten property
    var extra = opts.extraAddon || null;  // {id, price, freeUnits}: linea addon por zona grabada por encima de freeUnits (recuerdos)
    var grp = opts.grp || genGroupId();
    var main = { id: state.variantId, quantity: 1, properties: {} };
    var addons = [];
    (state.chapitas || []).forEach(function (c, i) {
      var n = i + 1;
      if (isOptionalUnit(optional, i) && !(c.front && c.front.trim())) return; // vacía a propósito: fuera del payload
      main.properties[unitFrontLabel(labels, i)] = c.front;
      if (c.backOn && addon) {
        main.properties[label(labels.back, n)] = c.back;
        addons.push({ id: addon.id, quantity: 1, properties: { _grp: grp, _chapita: String(n) } });
      }
    });
    if (extra) {
      var extras = Math.max(0, filledCount(state) - (extra.freeUnits || 1));
      for (var e = 0; e < extras; e++) addons.push({ id: extra.id, quantity: 1, properties: { _grp: grp, _zona: String(e + 2) } });
    }
    main.properties._grp = grp;
    return { items: [main].concat(addons) };
  }

  function findVariant(id, variants) {
    for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    return null;
  }

  function validateChapita(c, opt) {
    if (!c) return false;
    var empty = !c.front || !c.front.trim();
    if (empty) return !!opt; // vacía solo es válida si la unidad es opcional
    if (c.backOn && (!c.back || !c.back.trim())) return false;
    return true;
  }

  function isComplete(state, opts) {
    opts = opts || {};
    var ch = (state && state.chapitas) || [];
    if (!ch.length) return false;
    var ok = ch.every(function (c, i) { return validateChapita(c, isOptionalUnit(opts.optional, i)); });
    // allowEmpty: producto TOTALMENTE opcional (p.ej. tarjeta-dedicatoria) -> comprar con
    // todo vacio es un caso valido, no exigir >=1 unidad rellena.
    if (opts.allowEmpty) return ok;
    return ok && filledCount(state) > 0; // con opcionales normales, al menos una unidad grabada
  }

  function computeTotal(state, variants, addon, extraAddon) {
    var v = findVariant(state.variantId, variants || []);
    var base = v ? v.price : 0;
    if (addon) {
      var backs = (state.chapitas || []).filter(function (c) { return c.backOn; }).length;
      base += backs * addon.price;
    }
    if (extraAddon) base += Math.max(0, filledCount(state) - (extraAddon.freeUnits || 1)) * extraAddon.price;
    return base;
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function boot() {
    var cfgEl = document.querySelector('[data-pw-config]');
    var overlay = document.querySelector('[data-pw-overlay]');
    if (!cfgEl || !overlay) return;
    // GUARD DE ACTIVACION: el gate CSS solo oculta el boton .pw-open, pero boot() ademas
    // instala el interceptor de submit del ATC. Con el mount generico en TODOS los
    // personalizables (5d32665), sin este guard el interceptor secuestraba el add nativo
    // en productos SIN wizard publicado y tiraba las properties de Textify (pedidos con
    // 'Chapita 1 (Frontal)' en Promesa/Alianza/Pacto/Placa... 18-20 jul). Solo bootear
    // si la activacion (PW_LIVE o preview ?pw=1) puso html.pw-preview.
    if (!document.documentElement.classList.contains('pw-preview')) return;
    if (overlay.dataset.pwInit) return;
    overlay.dataset.pwInit = '1';
    // Portal: mover el overlay a <body> para que position:fixed no quede atrapado por
    // un ancestro con transform y cubra la pantalla completa (incluido el header).
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
    var cfg = JSON.parse(cfgEl.textContent);
    var variants = cfg.variants;
    var prod = PRODUCTS[cfg.handle] || {};
    var ADDON = prod.addon || null;   // null = solo grabado frontal
    var PLATES = prod.plates || null; // null = resumen sin imagen/pins
    var UNIT = prod.unit || { one: 'plaquita', many: 'plaquitas' };
    var LBL = prod.labels || LABELS;  // label de property por producto (default: Chapita)
    // Límite de caracteres: manda el metafield del producto (custom.grabado_max_caracteres,
    // editable desde el admin), luego el registro de aquí abajo y por último el global.
    var ML = cfg.maxlen || prod.maxlen || MAXLEN;
    // Límite POR PIEZA. Manda la lista del metafield (una entrada por pieza, mismo orden
    // que los pasos); si falta, viene corta o trae un 0, esa pieza cae al límite general.
    var MLS = (cfg.maxlens && cfg.maxlens.length) ? cfg.maxlens : (prod.maxlens || []);
    function mlFor(i) { var v = parseInt(MLS[i], 10); return v > 0 ? v : ML; }
    var OPTIONAL = prod.optional || null;     // unidades 1-based que pueden ir vacías
    var EXTRA = prod.extraAddon || null;      // addon por zona extra grabada (recuerdos)
    var UNITNAMES = prod.unitNames || null;   // nombre humano por unidad (badge/pasos/resumen)
    var GATE = prod.gate || null;             // {option:'color', skip:'Sin texto'}: esa variante compra SIN wizard
    var ALLOW_EMPTY = !!prod.allowEmpty;      // producto totalmente opcional (tarjeta-dedicatoria): añadir con todo vacío es válido
    var LONG = !!prod.longText;               // textarea alta (no una línea) vía .pw-field--long
    function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

    var state = { variantId: null, chapitas: [] };
    var step = 0; // 0..N-1 chapitas, N = review
    var editingReview = false;
    var lastFocus = null;
    var savedScrollY = 0;

    var bodyEl = overlay.querySelector('[data-pw-body]');
    var titleEl = overlay.querySelector('[data-pw-title]');
    var stepEl = overlay.querySelector('[data-pw-stepnum]');
    var errEl = overlay.querySelector('[data-pw-error]');
    var backBtn = overlay.querySelector('[data-pw-back]');
    var nextBtn = overlay.querySelector('[data-pw-next]');
    var progressEl = overlay.querySelector('[data-pw-progress]');
    var badgeEl = overlay.querySelector('[data-pw-badge]');
    var priceEl = overlay.querySelector('[data-pw-price]');
    var scrollEl = overlay.querySelector('.pw-scroll');

    function currentVariant() { return findVariant(state.variantId, variants); }
    function nCh() { if (prod.fixedUnits) return prod.fixedUnits; var v = currentVariant(); return (v && v.nombres) || 1; }

    function ensureChapitas() {
      var n = nCh();
      while (state.chapitas.length < n) state.chapitas.push({ front: '', back: '', backOn: false });
      state.chapitas.length = n;
    }

    // API de test + selección real de variante
    function selectVariant(id) { state.variantId = id; ensureChapitas(); syncAvailability(); }

    // GATE por variante (Lord): con la variante 'skip' (p.ej. Modelo='Sin texto') el
    // producto se compra SIN wizard → boton oculto, ATC nativo visible y sin intercept.
    function gateSkipped(id) {
      if (!GATE) return false;
      var v = findVariant(id != null ? id : readSelectedVariantId(), variants);
      if (!v) return false;
      var value = v[GATE.option || 'color'];
      return value === GATE.skip || (GATE.skip === 'Sin texto' && /^sem texto$/i.test(String(value || '').trim()));
    }
    function syncGate() {
      if (!GATE) return;
      // Con la variante 'skip' (Lord 'Sin texto') NO se resucita el ATC nativo: Textify
      // tambien intercepta su submit y lo traga (por eso esconde el boton y clona el suyo).
      // En su lugar, el boton del wizard se relabela a 'AÑADIR A LA CESTA' y openWizard
      // hace un add DIRECTO sin modal (ver gateDirectAdd).
      var skip = gateSkipped(null);
      document.querySelectorAll('[data-pw-open]').forEach(function (b) {
        var textNode = b.firstChild && b.firstChild.nodeType === 3 ? b.firstChild : null;
        if (!b.dataset.pwAvailableLabel) b.dataset.pwAvailableLabel = textNode ? textNode.nodeValue : b.textContent;
        var lbl = skip ? lpmText('AÑADIR A LA CESTA') : b.dataset.pwAvailableLabel;
        if (textNode) textNode.nodeValue = lbl;
        else if (b.textContent !== lbl) b.textContent = lbl;
      });
    }
    var gateAddBusy = false;
    function gateDirectAdd() {
      if (gateAddBusy) return; gateAddBusy = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: readSelectedVariantId(), quantity: 1 }] })
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (c) { syncCartNote(c); document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: c } })); })
            .catch(function () { document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: {} })); });
        })
        .catch(function () {})
        .then(function () { gateAddBusy = false; });
    }

    // Leer la variante seleccionada del form de producto
    function readSelectedVariantId() {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = input ? parseInt(input.value, 10) : NaN;
      return findVariant(id, variants) ? id : (variants[0] && variants[0].id);
    }

    function money(cents) {
      // SOPH: moneda de la tienda (GBP) en vez del sufijo fijo en euros de LPM.
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: cur }).format(cents / 100); }
      catch (e) { return '£' + (cents / 100).toFixed(2); }
    }

    function renderProgress() {
      if (!progressEl) return;
      var total = nCh() + 1, html = '';
      for (var i = 0; i < total; i++) {
        html += '<span class="' + (i < step ? 'is-done' : (i === step ? 'is-current' : '')) + '"></span>';
      }
      progressEl.innerHTML = html;
    }

    // Total visible desde el primer paso (en el resumen ya se muestra en cuerpo y boton)
    function renderPrice() {
      if (!priceEl) return;
      var onReview = step >= nCh();
      priceEl.hidden = onReview;
      if (!onReview) priceEl.textContent = lpmText('Total: ') + money(computeTotal(state, variants, ADDON, EXTRA));
    }

    function afterRender(focusField) {
      renderProgress();
      renderPrice();
      if (scrollEl) scrollEl.scrollTop = 0;
      bodyEl.style.animation = 'none'; void bodyEl.offsetWidth; bodyEl.style.animation = '';
      if (focusField) { var f = bodyEl.querySelector('textarea'); if (f) { f.focus(); keepActionsVisible(); } }
    }

    function render() { renderStep(); }

    function renderStep() {
      ensureChapitas();
      var n = nCh();
      errEl.hidden = true;
      if (step < n) {
        var c = state.chapitas[step];
        var uname = UNITNAMES && UNITNAMES[step];
        var isOpt = isOptionalUnit(OPTIONAL, step);
        stepEl.textContent = lpmText('Paso ') + (step + 1) + lpmText(' de ') + (n + 1);
        if (badgeEl) { badgeEl.hidden = n <= 1; badgeEl.textContent = lpmText(uname) || (lpmText(cap(UNIT.one)) + ' ' + (step + 1)); }
        titleEl.textContent = lpmText((prod.stepTitles && prod.stepTitles[step]) || prod.stepTitle || (uname ? lpmText('Grabado: ') + lpmText(uname) : lpmText('Tu grabado')));
        var fLabel = lpmText((prod.frontLabels && prod.frontLabels[step]) || prod.frontLabel || '¿Qué grabamos delante? (frontal)');
        bodyEl.innerHTML =
          contextHTML() + '<div class="pw-field' + (LONG ? ' pw-field--long' : '') + '"><label for="pw-front">' + fLabel + (isOpt ? ' <span class="pw-opt">(opcional' + (EXTRA ? ' · +' + money(EXTRA.price) + lpmText(' si la grabas') : '') + ')</span>' : '') + '</label>' +
            '<textarea id="pw-front" aria-describedby="pw-front-limit" maxlength="' + mlFor(step) + '" rows="' + (LONG ? 4 : 1) + '" data-pw-front placeholder="' + esc(lpmText(prod.placeholder || (isOpt ? 'Déjalo vacío si no quieres grabar esta zona' : 'Introduce el texto que quieras grabar'))) + '">' + esc(c.front) + '</textarea>' +
            '<div class="pw-count" id="pw-front-limit"><span data-pw-count>' + c.front.length + '</span>/' + mlFor(step) + '</div></div>' +
          (ADDON ?
            '<label class="pw-toggle"><input type="checkbox" data-pw-backon' + (c.backOn ? ' checked' : '') + '>' + lpmText(' Grabar también por detrás (+') + money(ADDON.price) + ')</label>' +
            '<div class="pw-field' + (LONG ? ' pw-field--long' : '') + '" data-pw-backwrap' + (c.backOn ? '' : ' hidden') + '><label for="pw-back">' + lpmText("¿Qué grabamos detrás? (trasero)") + '</label>' +
              '<textarea id="pw-back" aria-describedby="pw-back-limit" maxlength="' + mlFor(step) + '" rows="' + (LONG ? 4 : 1) + '" data-pw-back placeholder="' + esc(lpmText(prod.placeholder || 'Introduce el texto que quieras grabar')) + '">' + esc(c.back) + '</textarea>' +
              '<div class="pw-count" id="pw-back-limit"><span data-pw-backcount>' + c.back.length + '</span>/' + mlFor(step) + '</div></div>'
          : '');
        nextBtn.textContent = editingReview ? lpmText('Revisar cambios') : (step + 1 < n) ? lpmText('Siguiente') : lpmText('Revisar');
      } else {
        if (badgeEl) badgeEl.hidden = true;
        stepEl.textContent = lpmText('Último paso');
        titleEl.textContent = lpmText(prod.reviewTitle || 'Revisa tu grabado');
        var v = currentVariant();
        var maps = PLATES && PLATES[nCh()];
        var hero = '';
        if (v && v.image && maps && maps.length) {
          var pins = maps.map(function (p, i) {
            return '<span class="pw-pin" style="left:' + p.x + '%;top:' + p.y + '%">' + (i + 1) + '</span>';
          }).join('');
          hero = '<div class="pw-hero"><img src="' + esc(v.image) + '" alt="">' + pins + '</div>';
        }
        var rows = state.chapitas.map(function (c, i) {
          var unitName = lpmText(UNITNAMES && UNITNAMES[i]) || (lpmText(cap(UNIT.one)) + ' ' + (i + 1));
          var editFront = '<button type="button" class="pw-edit" data-pw-edit="' + i + '" data-pw-edit-field="front" aria-label="Editar ' + esc(unitName) + '">' + lpmText('Editar') + '</button>';
          if (isOptionalUnit(OPTIONAL, i) && !(c.front && c.front.trim())) {
            return '<div class="pw-sum"><span>' + esc(unitName) + '</span><b class="pw-sum-skip">' + lpmText(prod.skipLabel || "sin grabar") + '</b>' + editFront + '</div>';
          }
          var name = (UNITNAMES && UNITNAMES[i]) ? lpmText(UNITNAMES[i]) : (lpmText(prod.sumLabel) || (lpmText(cap(UNIT.one)) + ' ' + (i + 1) + lpmText(' · frontal')));
          return '<div class="pw-sum"><span>' + esc(name) + '</span><b>' + esc(c.front) + '</b>' + editFront + '</div>' +
            (c.backOn && ADDON ? '<div class="pw-sum"><span>' + esc(unitName) + lpmText(' · detrás (+') + money(ADDON.price) + ')</span><b>' + esc(c.back) + '</b><button type="button" class="pw-edit" data-pw-edit="' + i + '" data-pw-edit-field="back" aria-label="Editar ' + esc(unitName) + lpmText(' detrás') + '">' + lpmText('Editar') + '</button></div>' : '');
        }).join('');
        var extrasN = EXTRA ? Math.max(0, filledCount(state) - (EXTRA.freeUnits || 1)) : 0;
        if (extrasN) rows += '<div class="pw-sum"><span>' + lpmText("Grabado adicional × ") + extrasN + '</span><b>+' + money(extrasN * EXTRA.price) + '</b></div>';
        bodyEl.innerHTML = contextHTML(true, !!hero) + hero + rows + '<div class="pw-total"><span>Total</span><span>' + money(computeTotal(state, variants, ADDON, EXTRA)) + '</span></div>';
        bodyEl.insertAdjacentHTML('beforeend', '<p class="pw-review-note">' + lpmText("Comprueba el texto y el acabado.") + '</p>');
        nextBtn.textContent = lpmText('Añadir a la cesta · ') + money(computeTotal(state, variants, ADDON, EXTRA));
      }
      // Reserve feedback space before interaction so a blur cannot move the next tap target.
      bodyEl.querySelectorAll('[data-pw-front],[data-pw-back]').forEach(function(input){
        var message = document.createElement('p');message.id = input.id + '-feedback';
        message.className = 'pw-feedback';message.setAttribute('role','status');
        input.closest('.pw-field').appendChild(message);
        input.setAttribute('aria-describedby',(input.getAttribute('aria-describedby') || '') + ' ' + message.id);
      });
      backBtn.hidden = step === 0 && !editingReview;
      backBtn.textContent = editingReview ? lpmText('Volver al resumen') : lpmText('Atrás');
      updateNextEnabled();
      afterRender(step < n);
    }

    function contextHTML(review, hasHero) {
      var v = currentVariant();
      var image = v && v.image && !hasHero ? '<img src="' + esc(v.image) + '" alt="' + esc(cfg.title || lpmText('Tu joya')) + '">' : '';
      var description = (prod.unitKey === 'name' || cfg.kind === 'cut') ? lpmText('Tu nombre se recorta en el metal. Escríbelo tal como quieres que aparezca.') : lpmText('Escribe el texto para esta pieza. Podrás revisarlo antes de añadirla a la cesta.');
      var selection = v && (v.title || v.color) || '';
      var units = nCh() + ' ' + (nCh() === 1 ? lpmText(UNIT.one) : lpmText(UNIT.many));
      return '<div class="pw-context' + (review ? ' pw-context--review' : '') + '">' + image + '<strong>' + esc(cfg.title || '') + '</strong><br>' + esc(selection) +
        '<br>' + (review ? esc(units) : description) +
        (cfg.production ? '<br>' + esc(cfg.production) + lpmText(' Transporte aparte.') : '') +
        (review ? '<button type="button" class="pw-edit pw-edit-selection" data-pw-edit-selection>' + lpmText("Cambiar selección en la ficha") + '</button>' : '') + '</div>';
    }
    function syncAvailability() {
      var v = currentVariant() || findVariant(readSelectedVariantId(), variants);
      var unavailable = !v || v.available === false;
      document.querySelectorAll('[data-pw-open]').forEach(function (button) {
        button.disabled = unavailable;
        button.setAttribute('aria-disabled', String(unavailable));
        if (button.classList.contains('pw-open')) {
          if (!button.dataset.pwAvailableLabel) button.dataset.pwAvailableLabel = button.textContent.trim();
          var label = unavailable ? lpmText('Agotado') : button.dataset.pwAvailableLabel;
          if (button.textContent !== label) button.textContent = label;
        } else if (button.firstChild && button.firstChild.nodeType === 3) {
          if (!button.dataset.pwAvailableLabel) button.dataset.pwAvailableLabel = button.firstChild.nodeValue;
          button.firstChild.nodeValue = unavailable ? lpmText('Agotado') + (button.querySelector('span') ? ' · ' : '') : button.dataset.pwAvailableLabel;
        }
      });
    }

    function updateNextEnabled() {
      var n = nCh();
      if (step < n) nextBtn.disabled = !validateChapita(state.chapitas[step], isOptionalUnit(OPTIONAL, step));
      else nextBtn.disabled = !isComplete(state, { optional: OPTIONAL, allowEmpty: ALLOW_EMPTY });
      if (!currentVariant() || currentVariant().available === false) nextBtn.disabled = true;
      renderPrice();
    }

    function fieldFeedback(input) {
      if (!input.matches('[data-pw-front],[data-pw-back]')) return;
      var optional = input.matches('[data-pw-front]') && isOptionalUnit(OPTIONAL, step);
      var valid = optional || Boolean(input.value.trim());
      var pt = (document.documentElement.lang || '').slice(0,2) === 'pt';
      var id = input.id + '-feedback';
      var message = bodyEl.querySelector('#' + id);
      if (!message) {
        message = document.createElement('p'); message.id = id;
        message.className = 'pw-feedback'; message.setAttribute('role','status');
        input.closest('.pw-field').appendChild(message);
        input.setAttribute('aria-describedby', (input.getAttribute('aria-describedby') || '') + ' ' + id);
      }
      input.dataset.pwTouched = 'true';
      input.setAttribute('aria-invalid', String(!valid));
      message.dataset.valid = String(valid);
      message.textContent = !valid ? (pt ? 'Escreve o texto que queres gravar.' : 'Type the text you want engraved.') :
        !input.value.trim() ? (pt ? (prod.msgOptional && prod.msgOptional.pt) || 'Opcional: esta zona fica sem gravação.' : (prod.msgOptional && (prod.msgOptional.en || prod.msgOptional.es)) || 'Optional: this area will not be engraved.') :
        input.value.length === input.maxLength ? (pt ? '✓ Limite de caracteres atingido. Revê o texto.' : '✓ Character limit reached. Check your text.') :
        (pt ? '✓ Texto introduzido. Podes revê-lo antes de adicionar.' : '✓ Text added. You can review it before adding.');
    }
    bodyEl.addEventListener('focusout', function(e){fieldFeedback(e.target);});
    var navVisibilityTimer;
    function keepActionsVisible() {
      clearTimeout(navVisibilityTimer);
      navVisibilityTimer = setTimeout(function () {
        var field = bodyEl.querySelector('textarea:focus');
        if (overlay.hidden || !field) return;
        var vv = window.visualViewport;
        var visibleTop = vv ? vv.offsetTop : 0;
        var visibleBottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
        var navRect = nextBtn.getBoundingClientRect();
        var fieldRect = field.getBoundingClientRect();
        var fieldBottomLimit = Math.min(navRect.top, visibleBottom - 10) - 10;
        var delta = fieldRect.bottom > fieldBottomLimit ? fieldRect.bottom - fieldBottomLimit :
          fieldRect.top < visibleTop + 10 ? fieldRect.top - visibleTop - 10 : 0;
        if (delta) scrollEl.scrollBy({ top: delta, behavior: 'smooth' });
      }, 120);
    }
    bodyEl.addEventListener('focusin', function (e) {
      if (e.target.matches('[data-pw-front],[data-pw-back]')) keepActionsVisible();
    });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', keepActionsVisible);
      window.visualViewport.addEventListener('scroll', keepActionsVisible);
    }
    bodyEl.addEventListener('input', function (e) {
      var c = state.chapitas[step]; if (!c) return;
      if (e.target.matches('[data-pw-front]')) { c.front = e.target.value; overlay.querySelector('[data-pw-count]').textContent = c.front.length; }
      if (e.target.matches('[data-pw-back]')) { c.back = e.target.value; overlay.querySelector('[data-pw-backcount]').textContent = c.back.length; }
      if (e.target.dataset.pwTouched) fieldFeedback(e.target);
      updateNextEnabled();
    });
    bodyEl.addEventListener('change', function (e) {
      if (e.target.matches('[data-pw-backon]')) {
        var c = state.chapitas[step]; c.backOn = e.target.checked;
        overlay.querySelector('[data-pw-backwrap]').hidden = !c.backOn;
        updateNextEnabled();
      }
    });
    bodyEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-pw-edit-selection]')) { closeModal(); return; }
      var edit = e.target.closest('[data-pw-edit]');
      if (!edit) return;
      var target = parseInt(edit.dataset.pwEdit, 10);
      if (target < 0 || target >= nCh() || !Number.isFinite(target)) return;
      editingReview = true; step = target; render();
      var field = bodyEl.querySelector(edit.dataset.pwEditField === 'back' ? '[data-pw-back]' : '[data-pw-front]');
      if (field) field.focus();
    });

    function next() {
      var n = nCh();
      if (step < n) { if (!validateChapita(state.chapitas[step], isOptionalUnit(OPTIONAL, step))) return; step = editingReview ? n : step + 1; editingReview = false; render(); }
      else { submit(); }
    }
    function back() {
      if (editingReview) { step = nCh(); editingReview = false; render(); return; }
      if (step === 0) return;
      step--; render();
    }
    nextBtn.addEventListener('click', next);
    backBtn.addEventListener('click', back);


    // NOTA DE CARRITO para Outvio/almacén: resumen de grabados por SKU (lo escribía Textify
    // en LUMEA via nota; el Flow de pedido le antepone la cabecera 'Contiene Personalizable').
    // Se reconstruye desde el carrito completo -> idempotente entre adds.
    function syncCartNote(cart) {
      try {
        var lines = [];
        (cart.items || []).forEach(function (it) {
          var props = it.properties || {};
          var keys = Object.keys(props).filter(function (k) { return k && k.charAt(0) !== '_' && String(props[k] == null ? '' : props[k]).trim(); });
          if (!keys.length) return;
          lines.push((it.sku || it.product_title || '') + ':');
          keys.forEach(function (k) { lines.push(k + ': ' + props[k]); });
        });
        // _pw_note = copia de control: permite a lpm-cart-note-sync distinguir nuestra nota
        // de una escrita por el cliente, y rehacerla si luego se quita la pieza del carrito.
        var nota = lines.join('\n');
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: nota, attributes: { _pw_note: nota } })
        }).catch(function () {});
      } catch (e) {}
    }
    function submit() {
      if (!isComplete(state, { optional: OPTIONAL, allowEmpty: ALLOW_EMPTY }) || !currentVariant() || currentVariant().available === false) return;
      nextBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(buildCartPayload(state, { addon: ADDON, labels: LBL, optional: OPTIONAL, extraAddon: EXTRA }))
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          closeModal();
          // detail con el carrito real: listeners (Prestige/drawer nativo) leen e.detail.cart sin guardas
          fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (c) { syncCartNote(c); document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: c } })); })
            .catch(function () { document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: {} })); });
        })
        .catch(function () { errEl.hidden = false; errEl.textContent = lpmText('No se pudo añadir a la cesta. Inténtalo de nuevo.'); nextBtn.disabled = false; });
    }

    function openModal() {
      lastFocus = document.activeElement;
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = -savedScrollY + 'px';
      document.body.classList.add('pw-lock');
      ensureChapitas(); step = 0; editingReview = false; overlay.hidden = false; render();
    }
    function closeModal() {
      overlay.hidden = true;
      document.body.classList.remove('pw-lock');
      document.body.style.top = '';
      window.scrollTo(0, savedScrollY);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }
    overlay.querySelector('[data-pw-close]').addEventListener('click', closeModal);
    // Click fuera del modal NO cierra (por peticion): solo la X o Escape.
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closeModal(); });

    // Prestige re-renderiza la seccion del producto al cambiar de variante y vuelve a pintar
    // el markup del overlay DENTRO de la seccion -> aparecen overlays duplicados (uno por cambio)
    // que se apilan al abrir el wizard (clicks confusos). Podamos: solo sobrevive el overlay
    // inicializado (movido a <body>); las copias de la seccion se eliminan.
    function pruneDuplicateOverlays() {
      var all = document.querySelectorAll('[data-pw-overlay]');
      for (var i = 0; i < all.length; i++) {
        if (all[i] !== overlay && all[i].parentNode) all[i].parentNode.removeChild(all[i]);
      }
    }

    function openWizard(id) {
      selectVariant(id != null ? id : readSelectedVariantId());
      if (!currentVariant() || currentVariant().available === false) return;
      if (gateSkipped(state.variantId)) { gateDirectAdd(); return; }
      pruneDuplicateOverlays(); openModal();
    }

    // CTA que sustituye al ATC nativo (type=button, no envia el form): solo abre el wizard.
    // DELEGADO en document: Prestige re-renderiza la seccion del producto al cambiar de
    // variante y reemplaza el boton; con binding directo el boton nuevo quedaba muerto.
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-pw-open]') : null;
      if (t) { e.preventDefault(); openWizard(); }
    });

    // Red de seguridad: interceptar el submit del form de producto SOLO si la variante
    // enviada pertenece a este producto (por id). En captura + stopImmediatePropagation
    // para ganar al handler de Prestige. No afecta a productos relacionados (otras variantes).
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      var idInput = form.querySelector('[name="id"]');
      var id = idInput ? parseInt(idInput.value, 10) : NaN;
      if (!findVariant(id, variants)) return; // no es nuestro producto -> dejar add normal
      if (gateSkipped(id)) { e.preventDefault(); e.stopImmediatePropagation(); gateDirectAdd(); return; } // variante sin perso (Lord 'Sin texto') -> add directo
      e.preventDefault();
      e.stopImmediatePropagation();
      openWizard(id);
    }, true);

    // Listener para re-sincronizar cuando cambia la variante seleccionada en el form
    document.addEventListener('change', function (e) {
      if (e.target.matches('form[action*="/cart/add"] [name="id"]')) { pruneDuplicateOverlays(); selectVariant(readSelectedVariantId()); syncGate(); }
    });
    selectVariant(readSelectedVariantId());
    document.addEventListener('variant:change', function () { selectVariant(readSelectedVariantId()); });
    syncGate();
    // Prestige re-renderiza la seccion al cambiar de variante: reaplicar el gate tras cada mutacion
    if (GATE) new MutationObserver(function () { syncGate(); }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.PersoWizard = {
    PRODUCTS: PRODUCTS, LABELS: LABELS, MAXLEN: MAXLEN,
    genGroupId: genGroupId, buildCartPayload: buildCartPayload,
    computeTotal: computeTotal, validateChapita: validateChapita, isComplete: isComplete, findVariant: findVariant
  };
})();
